import spritemap from "@milestone-sys/web-design-system/msds-spritemap.svg"
import { useNavigate } from "react-router-dom"
import "./row-action.scss"

export const NavigateAction = ({ url, rowIndex }) => {
    const navigate = useNavigate()

    return (
        <button id={"xsd__e2e-table-actions-edit-row-" + rowIndex} className="row-action" type="button" onClick={() => navigate(url)} title="Edit">
            <svg className="msds-icon">
                <use href={`${spritemap}#edit`} />
            </svg>
        </button>
    )
}